import React from 'react';
export function OrgChart() {
  return <div className="overflow-x-auto pb-8" data-id="element-139">
      <div className="min-w-[800px] flex flex-col items-center" data-id="element-140">
        {/* Level 1: Director */}
        <div className="mb-8" data-id="element-141">
          <div className="bg-blue-900 text-white px-8 py-4 rounded-lg shadow-md border border-blue-800 text-center w-64" data-id="element-142">
            <h3 className="font-bold text-lg" data-id="element-143">Director</h3>
          </div>
          <div className="h-8 w-0.5 bg-slate-300 mx-auto" data-id="element-144"></div>
        </div>

        {/* Level 2: Managers */}
        <div className="flex justify-center gap-8 relative" data-id="element-145">
          {/* Connector Line */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[85%] h-0.5 bg-slate-300 -mt-8" data-id="element-146"></div>

          {/* Vertical Lines to Connector */}
          <div className="absolute top-[-32px] left-[7.5%] w-0.5 h-8 bg-slate-300" data-id="element-147"></div>
          <div className="absolute top-[-32px] left-[35%] w-0.5 h-8 bg-slate-300" data-id="element-148"></div>
          <div className="absolute top-[-32px] right-[35%] w-0.5 h-8 bg-slate-300" data-id="element-149"></div>
          <div className="absolute top-[-32px] right-[7.5%] w-0.5 h-8 bg-slate-300" data-id="element-150"></div>

          {/* Office Division */}
          <div className="flex flex-col items-center w-64" data-id="element-151">
            <div className="bg-white border border-slate-200 p-4 rounded-lg shadow-sm w-full text-center mb-4" data-id="element-152">
              <h4 className="font-bold text-blue-900" data-id="element-153">Office Division</h4>
              <div className="text-xs text-slate-500 mt-2 space-y-1" data-id="element-154">
                <p data-id="element-155">Business Strategies</p>
                <p data-id="element-156">SCM (Marketing, Procurement)</p>
                <p data-id="element-157">QHSE Manager</p>
              </div>
            </div>
          </div>

          {/* Operating Division - Engineer Manager */}
          <div className="flex flex-col items-center w-64" data-id="element-158">
            <div className="bg-white border border-slate-200 p-4 rounded-lg shadow-sm w-full text-center mb-4" data-id="element-159">
              <h4 className="font-bold text-blue-900" data-id="element-160">Engineer Manager</h4>
              <div className="text-xs text-slate-500 mt-2 space-y-1" data-id="element-161">
                <p data-id="element-162">Procurement & Budgeting</p>
                <p data-id="element-163">Quantity Surveyor</p>
                <p data-id="element-164">Design & Planning</p>
              </div>
            </div>
          </div>

          {/* Operating Division - Operational Manager */}
          <div className="flex flex-col items-center w-64" data-id="element-165">
            <div className="bg-white border border-slate-200 p-4 rounded-lg shadow-sm w-full text-center mb-4" data-id="element-166">
              <h4 className="font-bold text-blue-900" data-id="element-167">Operational Manager</h4>
              <div className="text-xs text-slate-500 mt-2 space-y-1" data-id="element-168">
                <p data-id="element-169">Superintendent</p>
                <p data-id="element-170">Site Engineer</p>
                <p data-id="element-171">Surveyor</p>
              </div>
            </div>
          </div>

          {/* Accounting Manager */}
          <div className="flex flex-col items-center w-64" data-id="element-172">
            <div className="bg-white border border-slate-200 p-4 rounded-lg shadow-sm w-full text-center mb-4" data-id="element-173">
              <h4 className="font-bold text-blue-900" data-id="element-174">Accounting & Admin</h4>
              <div className="text-xs text-slate-500 mt-2 space-y-1" data-id="element-175">
                <p data-id="element-176">Administration/Cashier</p>
                <p data-id="element-177">Finance</p>
                <p data-id="element-178">Tax</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}